import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getFilterManagerUsers() {
  try {
    const response = yield call(api.getFilterManagerUsers);

    yield put(Creators.getFilterManagerUsersSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getFilterManagerUsersFailure());
  }
}
